<template>
    <v-dialog v-model="showDialog" max-width="500px">
        <v-card>
            <v-card-title :class="type.type" class="title white--text">
                {{type.title}}           
            </v-card-title>
            <v-card-text style="margin-top: 20px">
                <span class="text--primary">
                    <span>{{text}}</span>
                </span>                
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    ref="btnYes"
                    rounded
                    color="primary"                    
                    @click="confirm()"        
                    v-if="isConfirmDialog"            
                >
                    {{$vuetify.lang.t('$vuetify.dialog.yes')}}
                </v-btn>
                <v-btn
                    ref="btnClose"
                    rounded
                    color="grey lighten-3"                    
                    @click="close()"
                >
                    {{closeBtn}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import { mapState, mapMutations} from 'vuex'
    export default {
        data() {
            return {
                indexMessage: 0
            }
        },        
        computed: {
            ...mapState("dialog", ["type", "message", "show", 'fnCallback', 'isConfirmDialog', 'fnCallbackNo']),
            text() {                
                if (this.message && this.message.length) {
                    return this.message[this.indexMessage];
                }
                return '';
            },            
            showDialog: {
                get () {
                    return this.$store.state.dialog.show;
                },
                set (val) {                    
                    this.toggleShow(val);                       
                }
            },
            closeBtn() {
                return this.isConfirmDialog ? this.$vuetify.lang.t('$vuetify.dialog.no') : this.$vuetify.lang.t('$vuetify.dialog.close')
            },           
        },
        watch: {
            showDialog(newValue) {                            
                if (newValue) {                    
                    this.indexMessage = 0;
                    setTimeout(() => {
                        if (this.isConfirmDialog)
                            this.$refs.btnYes.$el.focus();
                        else 
                            this.$refs.btnClose.$el.focus();
                    }, 100)
                }
            }        
        },
        methods: {
            ...mapMutations("dialog", ["toggleShow", 'setCallback']),
            close() {     
                
                if (this.isConfirmDialog) {
                    this.toggleShow(this.$store.state.dialog.show);                                        
                    if (this.fnCallbackNo) {
                        this.fnCallbackNo();
                        this.setCallback(null);
                    }
                } else {
                    if (this.indexMessage + 1 == this.message.length) {                    
                        this.toggleShow(this.$store.state.dialog.show);                                        
                        if (this.fnCallback) {
                            this.fnCallback();
                            this.setCallback(null);
                        }
                    } else {
                        this.indexMessage++;
                        setTimeout(() => {
                            this.$refs.btnClose.$el.focus();
                        }, 100)
                    }
                }
            },
            confirm() {                
                this.toggleShow(this.$store.state.dialog.show);                
                if (this.fnCallback) {
                    this.fnCallback();
                    this.setCallback(null);
                }
            }
        }

    }
</script>